<template>
  <div class="login-page">
    <app-navbar />
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter
        page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <info-section
                class="mt-5"
                type="danger"
                title="Marketing"
                description="We've created the marketing campaign of the website.
                  It was a very interesting collaboration."
                icon="nc-icon nc-alert-circle-i"
              >
                <h2 class="text-white mt-3">
                  Maintenance Mode
                </h2>
                <small class="text-white">
                  We are currently working on Acts. Sorry for this inconvenience.
                  <br>
                </small>
              </info-section>
            </div>
          </div>
        </div>
        <app-footer />
        <div class="full-page-background" style="background-image: url(static/img/background/jan-sendereks.jpg) " />
      </div>
    </div>
  </div>
</template>
<script>
import {
    Checkbox, Button, InfoSection
} from 'src/components/UIComponents';
import AppNavbar from 'src/components/Layout/LoginAppNavbar';
import AppFooter from 'src/components/Layout/LoginAppFooter';

export default {
    components: {
        AppNavbar,
        AppFooter,
        InfoSection,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
    },
    methods: {
        toggleNavbar() {
            document.body.classList.toggle('nav-open');
        },
        closeMenu() {
            document.body.classList.remove('nav-open');
            document.body.classList.remove('off-canvas-sidebar');
        }
    },
    beforeDestroy() {
        this.closeMenu();
    }
};
</script>
<style>
</style>
